// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"bc3ab7c6","125":"010e7907","218":"ba8735d6","462":"8d028805","640":"8206dfbe"}[chunkId] + ".chunk.js";
};